import { Component, OnInit } from '@angular/core';
import { Budget } from '../../../models/budgets/budget';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BudgetService } from '../../../services/budget.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertService } from '../../../services/alert.service';
import { DateHelper } from '../../../helpers/DateHelper';
import { Helper } from '../../../helpers/Helper';
import { CustomValidators } from '../../../validators/customValidators';
import { environment } from '../../../../environments/environment';

@Component({
	selector: 'app-budget-form',
	templateUrl: './budget-form.component.html',
	styleUrls: ['./budget-form.component.css']
})
export class BudgetFormComponent implements OnInit {

	form: FormGroup;
	budget: Budget = new Budget();
	loading: boolean = false;

	constructor(
		private _budgetService: BudgetService,
		private _activatedRoute: ActivatedRoute,
		private _router: Router,
		private _alertService: AlertService
	) { }

	ngOnInit() {
		this._activatedRoute.params.subscribe(
			x => {
				this.init();
			}
		);
	}

	private init(){
		let id = this._activatedRoute.snapshot.params['id'];
		this.budget = new Budget();
		this.budget.id = id;


		if (id == 0) {
			this.budget.id = 0;
			this.budget.dateRecieved = DateHelper.getDateNowString();
			this.budget.releasedById = Helper.currentUserId();
			this.budget.recieverId = environment.budget_defaultRecieverId;

			this.form = this.createForm(this.budget);
		}
		else {
			this.form = this.createForm(this.budget);
			this._budgetService.getBudget(id).subscribe(
				result => {
					if (result == undefined) {
						this.budget.id = 0;
					}
					else {
						this.budget = result;
						this.form = this.createForm(this.budget)
					}
				}
			);
		}
	}

	private createForm(budget: Budget): FormGroup {
		return new FormGroup({
			recieverId: new FormControl(budget.recieverId, [
				Validators.required
			]),
			amount: new FormControl(budget.amount, [
				Validators.required,
				CustomValidators.validateCurrency
            ]),
            type: new FormControl(budget.type, [
				Validators.required
			]),
			releasedById: new FormControl(budget.releasedById, [
				Validators.required
			]),
			dateRecieved: new FormControl(budget.dateRecieved, [
				Validators.required
			]),
			remarks: new FormControl(budget.remarks, [
				CustomValidators.maxLength(100)
            ]),
		});
	}

	onFormSubmit(formValue) {
		if(!this.form.valid){
			this._alertService.showError('Invalid form data.');
			return;
		}
		
		this.budget.recieverId = formValue.recieverId;
        this.budget.amount = formValue.amount;
        this.budget.type = formValue.type;
		this.budget.releasedById = formValue.releasedById;
		this.budget.dateRecieved = formValue.dateRecieved;
		this.budget.remarks = formValue.remarks;

		this.loading = true;
		if (this.budget.id == undefined || this.budget.id == 0) {
			this.create();
		}
		else {
			this.update();
		}
	}

	private create() {
		this._budgetService.addBudget(this.budget).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.budget = result.object;
					this.createForm(this.budget);
					this._alertService.showSuccess('Budget information has been filed.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	private update() {
		this._budgetService.updateBudget(this.budget).subscribe(
			result => {
				if (result != undefined && result['object'] != undefined) {
					this.budget = result.object;
					this.createForm(this.budget);
					this._alertService.showSuccess('Budget information has been updated.');
				}
				else {
					this._alertService.displayErrorResult(result.errorCollection);
				}
				this.loading = false;
			}
		);
	}

	isControlInvalid(controlName: string) {
		let control = this.form.controls[controlName];
		return control.invalid && (control.dirty || control.touched);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/budgets/budget-form/budget-form.component.ts